const userDataFormValidationHR = {
    "firstName": {
        "required": "Ime je obavezno"
    },
    "lastName": {
        "required": "Prezime je obavezno"
    },
    "personalStreet": {
        "required": "Ulica i broj su obavezni"
    },
    "personalZip": {
        "required": "Poštanski broj je obavezan"
    },
    "personalCity": {
        "required": "Grad je obavezan"
    },
    "personalCountry": {
        "required": "Država je obavezna"
    },
    "businessType": {
        "required": "Vrsta poslovanja je obavezna"
    },
    "companyName": {
        "required": "Naziv tvrtke je obavezan"
    },
    "ceoFirstName": {
        "required": "Ime direktora je obavezno"
    },
    "ceoLastName": {
        "required": "Prezime direktora je obavezno"
    },
    "businessStreet": {
        "required": "Ulica i broj su obavezni"
    },
    "businessZip": {
        "required": "Poštanski broj je obavezan"
    },
    "businessCity": {
        "required": "Grad je obavezan"
    },
    "businessCountry": {
        "required": "Država je obavezna"
    },
    "tradeRegistryExport": {
        "file": "Molimo prenesite važeću PDF datoteku (maksimalna veličina 5 MB)."
    },
    "tradeRegistryExportURL": {
        "required": "Izvoz iz trgovačkog registra je obavezan"
    },
    "tradeRegistryCompanyUrl": {
        "required": "URL tvrtke u trgovačkom registru je obavezan"
    }
};

export default userDataFormValidationHR;